var map = {
	"./osmTagToNameMapping-cs.template.ts": [
		93704,
		3704
	],
	"./osmTagToNameMapping-cs.ts": [
		23734,
		3734
	],
	"./osmTagToNameMapping-de.template.ts": [
		70563,
		563
	],
	"./osmTagToNameMapping-de.ts": [
		92759,
		2759
	],
	"./osmTagToNameMapping-en.ts": [
		49535,
		9535
	],
	"./osmTagToNameMapping-hu.template.ts": [
		50143,
		143
	],
	"./osmTagToNameMapping-hu.ts": [
		88435,
		8435
	],
	"./osmTagToNameMapping-it.template.ts": [
		25329,
		5329
	],
	"./osmTagToNameMapping-it.ts": [
		47877,
		7877
	],
	"./osmTagToNameMapping-pl.template.ts": [
		81142,
		1142
	],
	"./osmTagToNameMapping-pl.ts": [
		19780,
		9780
	],
	"./osmTagToNameMapping-sk.template.ts": [
		47088,
		7088
	],
	"./osmTagToNameMapping-sk.ts": [
		23742,
		3742
	],
	"./osmTagToNameMapping-xx.template.ts": [
		17778,
		7778
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;